import { BaseMenuItem } from "./base-menu-item";
import { types } from "./menu-item-types";

export class RouterlinkMenuItem extends BaseMenuItem {
    constructor(icon, to) {
        super(types.routerlink, icon);
        this.to = to;
    }
}